import { render, staticRenderFns } from "./educate.vue?vue&type=template&id=5f19831f&scoped=true&"
import script from "./educate.vue?vue&type=script&setup=true&lang=js&"
export * from "./educate.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./educate.vue?vue&type=style&index=0&id=5f19831f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f19831f",
  null
  
)

export default component.exports